<script>
import Component from '~/sites/soh/pages/index'
export default {
  extends: Component,
}
</script>
